/**
 * Centralized env access. In `vite dev` the app uses same-origin URLs so
 * requests hit the Vite proxy → backend (avoids CORS). In production builds
 * VITE_API_BASE_URL must point at the Django host.
 */
function required(key: string, hint: string): string {
  const raw = import.meta.env[key] as string | undefined;
  if (!raw?.trim()) {
    throw new Error(`Missing required env var: ${key}. ${hint}`);
  }
  return raw.replace(/\/+$/, '');
}

const prodHint =
  'For production builds, copy .env.production.example to .env.production and set VITE_API_BASE_URL for your Django host.';

export const env = {
  apiBase: import.meta.env.DEV ? '' : required('VITE_API_BASE_URL', prodHint),
  isDev: import.meta.env.DEV,
};
